import HeroBannerDesktop from 'public/static/campaigns/rewards-program/hero-banner-desktop.png'
import HeroBannerMobile from 'public/static/campaigns/rewards-program/hero-banner-mobile.png'

import { BannerImage } from '../../../components/landings/styles'

import styles from './IntroBanner.module.scss'

const IntroBanner = () => (
  <div className={styles.bannerWrapper}>
    <div className={styles.desktopContent}>
      <BannerImage
        src={HeroBannerDesktop}
        alt='TWÓJ WYBÓR MA ZNACZENIE!'
        width={2566}
        height={1488}
        priority
      />
    </div>
    <div className={styles.tabletContent}>
      <BannerImage
        src={HeroBannerMobile}
        alt='TWÓJ WYBÓR MA ZNACZENIE!'
        width={1242}
        height={875}
        priority
      />
    </div>
  </div>
)

export default IntroBanner
